const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20talk%20show%20studio%20setup%20with%20warm%20lighting%20and%20comfortable%20seating%2C%20professional%20broadcast%20cameras%2C%20cozy%20atmosphere%2C%20soft%20coral%20and%20cream%20tones%2C%20modern%20studio%20design%2C%20no%20people%20visible&width=600&height=400&seq=media-01&orientation=landscape',
    title: '本期深度：娱乐圈"塌房"现象背后的产业逻辑',
    duration: '18:42',
    views: '56.8万',
    tag: '深度解读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Podcast%20recording%20studio%20with%20microphones%20and%20acoustic%20panels%2C%20warm%20ambient%20lighting%2C%20professional%20audio%20equipment%2C%20cozy%20creative%20space%2C%20soft%20amber%20and%20cream%20color%20palette%2C%20modern%20minimalist%20interior&width=600&height=400&seq=media-02&orientation=landscape',
    title: '吃瓜圆桌派：本月五大热点事件复盘',
    duration: '32:15',
    views: '42.3万',
    tag: '圆桌讨论',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Digital%20news%20studio%20with%20large%20screen%20displaying%20entertainment%20headlines%2C%20modern%20broadcast%20setup%2C%20warm%20professional%20lighting%2C%20clean%20contemporary%20design%2C%20soft%20coral%20accent%20elements%2C%20professional%20media%20environment&width=600&height=400&seq=media-03&orientation=landscape',
    title: '一周瓜报：速览7天娱乐圈大事记',
    duration: '8:55',
    views: '89.1万',
    tag: '周报速览',
  },
];

export default function MediaSection() {
  return (
    <section
      id="media"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            瓜视精选
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            精选视频解读，深度吃瓜更有料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col rounded-lg bg-background-100 border border-background-200/70 overflow-hidden transition-colors duration-200 hover:border-primary-200"
            >
              {/* Thumbnail */}
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                {/* Play overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-foreground-900/20 transition-opacity duration-200 group-hover:bg-foreground-900/30">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                {/* Duration badge */}
                <span className="absolute bottom-2 right-2 text-xs px-1.5 py-0.5 rounded bg-foreground-900/70 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
                {/* Tag */}
                <span className="absolute top-2 left-2 text-xs px-2 py-0.5 rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>

              {/* Content */}
              <div className="flex flex-col gap-1.5 p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span>播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}